var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2786 0H11.7056L0 11.7133V28.2788L11.7135 39.9921H28.2865L40 28.2788V11.7133L28.2786 0Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 32.5742C18.2601 32.5742 16.7769 31.961 15.5505 30.7347C14.3241 29.5083 13.7109 28.0251 13.7109 26.2851C13.7109 25.2788 13.9311 24.3407 14.3713 23.4707C14.8115 22.6007 15.43 21.8617 16.2266 21.2538V11.1912C16.2266 10.143 16.5935 9.25205 17.3272 8.51832C18.0609 7.78459 18.9519 7.41772 20.0001 7.41772C21.0482 7.41772 21.9392 7.78459 22.6729 8.51832C23.4067 9.25205 23.7735 10.143 23.7735 11.1912V21.2538C24.5702 21.8617 25.1886 22.6007 25.6288 23.4707C26.0691 24.3407 26.2892 25.2788 26.2892 26.2851C26.2892 28.0251 25.676 29.5083 24.4496 30.7347C23.2232 31.961 21.7401 32.5742 20.0001 32.5742ZM18.7422 18.7381H21.2579V17.4803H20.0001V16.2225H21.2579V13.7068H20.0001V12.449H21.2579V11.1912C21.2579 10.8348 21.1373 10.5361 20.8963 10.295C20.6552 10.0539 20.3564 9.93337 20.0001 9.93337C19.6437 9.93337 19.3449 10.0539 19.1039 10.295C18.8628 10.5361 18.7422 10.8348 18.7422 11.1912V18.7381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTemperature);
export default __webpack_public_path__ + "static/media/alert-temperature.2723918b76e9f5476c98dfab2ddd9bd2.svg";
export { ForwardRef as ReactComponent };